import COS from 'cos-js-sdk-v5'

let cos = null
let taskId = null
cos = new COS({
  getAuthorization: function (options, callback) {
    var url = 'https://online.tenghuiwangxiao.cn/common/index/getCosSign'
    console.log(url)
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.onload = function (e) {
      console.log(e)
      try {
        var data = JSON.parse(e.target.responseText)
        var credentials = data.data.credentials
      } catch (e) {
        console.log(e)
      }
      if (!data || !credentials) {
        return console.error('credentials invalid:\n' + JSON.stringify(data, null, 2))
      }
      // eslint-disable-next-line standard/no-callback-literal
      callback({
        TmpSecretId: credentials.tmpSecretId,
        TmpSecretKey: credentials.tmpSecretKey,
        SecurityToken: credentials.sessionToken,
        StartTime: data.data.startTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: data.data.expiredTime // 时间戳，单位秒，如：1580000000
      })
    }
    xhr.send()
  },
  UseAccelerate: true
})

function randomString (len) {
  len = len || 8
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

function cosUploadFile (file, uid, callback, fileName) {
  console.log('file', file)
  return new Promise(resolve => {
    const time = new Date()
    const y = time.getFullYear()
    let m = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1)
    const d = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()
    const name = fileName || file.name
    const fileNameTmp = randomString() + '_' + name
    const uploadPath = '/uploads/' + uid + '/' + y + '/' + m + '/' + d
    const storeAs = uploadPath + '/' + fileNameTmp
    cos.uploadFile(
      {
        Bucket: 'tengface-live-user-1308721187',
        /* 填入您自己的存储桶，必须字段 */
        Region: 'ap-guangzhou',
        /* 存储桶所在地域，例如ap-beijing，必须字段 */
        Key: storeAs,
        /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
        StorageClass: 'STANDARD',
        Body: file, // 上传文件对象
        onTaskReady: id => { /* 非必须 */
          // this.form.file[0].taskId = taskId
          taskId = id
        },
        onProgress: progressData => {
          if (callback) {
            callback(progressData, file.name)
          }
        }
      },
      async (err, data) => {
        if (data.statusCode === 200) {
          let url = `https://${data.Location}`
          resolve(url)
          taskId = null
        }
        if (err) {
          console.log(err)
        }
      }
    )
  })
}

function cancelTask () {
  if (taskId) {
    cos.cancelTask(taskId)
  }
}

export { cosUploadFile, cancelTask }



// WEBPACK FOOTER //
// ./src/kits/cosUpload.js